import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { InfiniteScrollModule } from 'ngx-infinite-scroll';

import { MatButtonModule} from '@angular/material/button';


import { MatIconModule } from '@angular/material/icon';




import { MatSelectModule } from '@angular/material/select';
import { ProviderCleaner } from './provider-cleaner';


@NgModule({
    imports: [
        CommonModule,
        FormsModule,
        MatButtonModule,
        MatIconModule,
        MatSelectModule,
    ],
    declarations: [
        ProviderCleaner,
    ],
    exports: [
        ProviderCleaner
    ]
})
export class ProviderCleanerModule { }
